import { render, staticRenderFns } from "./DeliveriesDetails.vue?vue&type=template&id=8f17ee2a&"
import script from "./DeliveriesDetails.vue?vue&type=script&lang=js&"
export * from "./DeliveriesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports